import { colorsPalettes } from "@similarweb/styles";

import { translate } from "app/filters/i18nFilter";

import type { ISourceConfig } from "./types";
import { TopicSourceType } from "./types";

const { midnight, brown, indigo, yellow, purple, blue, green, sky, teal, pink, bluegrey, mint, carbon } =
    colorsPalettes;

export const SOURCE_TYPES_CONFIG: Record<TopicSourceType, ISourceConfig> = {
    [TopicSourceType.SocialMedia]: {
        get text() {
            return translate("overview_report.topics.visibility.widget.column.source_types.social_media");
        },
        backgroundColor: sky[100],
        textColor: blue[600],
    },
    [TopicSourceType.ReviewsAndUGC]: {
        get text() {
            return translate("overview_report.topics.visibility.widget.column.source_types.reviews-and-ugc");
        },
        backgroundColor: indigo[50],
        textColor: indigo[500],
    },
    [TopicSourceType.NewsAndPublishers]: {
        get text() {
            return translate("overview_report.topics.visibility.widget.column.source_types.news-and-publishers");
        },
        backgroundColor: purple[50],
        textColor: purple[500],
    },
    [TopicSourceType.Marketplace]: {
        get text() {
            return translate("overview_report.topics.visibility.widget.column.source_types.marketplace");
        },
        backgroundColor: yellow[100],
        textColor: yellow[700],
    },
    [TopicSourceType.ECommerceBrands]: {
        get text() {
            return translate("overview_report.topics.visibility.widget.column.source_types.e-commerce-brands");
        },
        backgroundColor: teal[50],
        textColor: teal[600],
    },
    [TopicSourceType.BusinessServices]: {
        get text() {
            return translate("overview_report.topics.visibility.widget.column.source_types.business-services");
        },
        backgroundColor: pink[100],
        textColor: pink[500],
    },
    [TopicSourceType.FinancialServices]: {
        get text() {
            return translate("overview_report.topics.visibility.widget.column.source_types.financial-services");
        },
        backgroundColor: mint[50],
        textColor: mint[500],
    },
    [TopicSourceType.ConsumerServices]: {
        get text() {
            return translate("overview_report.topics.visibility.widget.column.source_types.consumer-services");
        },
        backgroundColor: green[100],
        textColor: green[500],
    },
    [TopicSourceType.SearchAndDiscovery]: {
        get text() {
            return translate("overview_report.topics.visibility.widget.column.source_types.search-and-discovery");
        },
        backgroundColor: brown[100],
        textColor: brown[600],
    },
    [TopicSourceType.MyDomain]: {
        get text() {
            return translate("overview_report.topics.visibility.widget.column.source_types.my_domain");
        },
        backgroundColor: bluegrey[200],
        textColor: bluegrey[600],
    },
    [TopicSourceType.CompetitorDomains]: {
        get text() {
            return translate("overview_report.topics.visibility.widget.column.source_types.competitor_domains");
        },
        backgroundColor: blue[100],
        textColor: midnight[400],
    },
    [TopicSourceType.DirectCompetitors]: {
        get text() {
            return translate("overview_report.topics.visibility.widget.column.source_types.direct_competitors");
        },
        backgroundColor: sky[100],
        textColor: midnight[500],
    },
    [TopicSourceType.Other]: {
        get text() {
            return translate("overview_report.topics.visibility.widget.column.source_types.other");
        },
        backgroundColor: carbon[25],
        textColor: carbon[400],
    },
};
